import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

@Component({
  selector: 'abb-page-unauthorized',
  standalone: true,
  imports: [TPipe],
  providers: [{ provide: TRANSLATION_PREFIX, useValue: 'commons' }],
  template: `
    <div
      class="flex flex-col items-center justify-center h-screen bg-abb-primary/20 text-abb-primary-dark text-center"
    >
      <h1 class="text-4xl font-bold mb-4">{{ 'Unauthorized Access' | t }}</h1>
      <p class="text-lg mb-6">
        {{ 'You do not have permission to view this page' | t }}.
      </p>
      <a
        (click)="router.navigate(['/'])"
        class="text-abb-primary-dark font-semibold hover:underline cursor-pointer"
        >{{ 'Return to Home' | t }}</a
      >
    </div>
  `,
  styles: ``,
})
export class PageUnauthorizedComponent {
  // TODO: se sono autenticato e non autorizzato dove devo essere indirizzato (return to home deve sloggarmi)?
  // TODO: se non ho il permesso di visualizzare la dashboard, dove devo essere ridiretto?
  constructor(public router: Router) {}
}
